import type { ComponentType } from 'react';

import AppleIcon from '@cartwhl/ui/icons/AppleIcon';
import WindowsIcon from '@cartwhl/ui/icons/WindowsIcon';

import type { BrandIconProps } from '@cartwhl/ui/icons/brandIconTypes';
import type { PluginDownloadOption, PluginPlatform } from './integrationsPageData';

export const pluginPlatformIcons: Record<
  PluginPlatform,
  ComponentType<BrandIconProps>
> = {
  windows: WindowsIcon,
  macos: AppleIcon,
};

export function detectPluginPlatform(): PluginPlatform {
  if (typeof navigator === 'undefined') {
    return 'windows';
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform?.toLowerCase() ?? '';

  if (
    /mac|darwin|iphone|ipad|ipod/.test(userAgent) ||
    platform.includes('mac')
  ) {
    return 'macos';
  }

  return 'windows';
}

export function getDefaultDownloadOption(
  options: PluginDownloadOption[],
  platform: PluginPlatform = detectPluginPlatform(),
): PluginDownloadOption {
  return (
    options.find((option) => option.platform === platform) ?? options[0]
  );
}
